import { View, LayoutChangeEvent, StyleProp, ViewStyle } from 'react-native';
import { Box, Button, NamespacedImageKeys, TextProps } from '@bonanza-social/moonlight';
import AdditionalRegisterInfo from '../../AdditionalRegisterInfo/AdditionalRegisterInfo';
import { StyleProps } from 'react-native-reanimated';
import FeatureTip from '../../FeatureTip/FeatureTip.web';

type DefaultRegistrationStepButtonProps = {
  containerStyle?: StyleProp<ViewStyle>;
  onLayout?: (event: LayoutChangeEvent) => void;
  animatedStyle?: StyleProps;
  onSubmit: () => void;
  ctaKey?: TextProps['locKey'];
  loading?: boolean;
  disabled?: boolean;
  featureTip?: {
    descriptionKey: TextProps['locKey'];
    image: NamespacedImageKeys;
  };
};

function DefaultRegistrationStepButton({
  containerStyle,
  onLayout,
  animatedStyle,
  onSubmit,
  ctaKey = 'nextButton',
  loading = false,
  disabled = false,
  featureTip,
}: DefaultRegistrationStepButtonProps) {
  return (
    <View style={containerStyle} onLayout={onLayout}>
      <Box
        animatedStyle={animatedStyle}
        width={{ mobile: '100%', tablet: '100%', desktop: 760 }}
        marginTop={{
          mobile: 'space-0',
          tablet: 'space-200',
          desktop: 'space-400',
        }}
        paddingHorizontal="space-400"
      >
        {featureTip && <FeatureTip featureTip={featureTip} />}
        <Button
          onPress={onSubmit}
          locNS="registration"
          locKey={ctaKey}
          loading={loading}
          disabled={disabled}
          variant="primary"
          size="large"
        />
      </Box>
      <AdditionalRegisterInfo />
    </View>
  );
}

export default DefaultRegistrationStepButton;
